import { inject, Injectable } from "@angular/core";
import { PathModuleName, PathProductName } from "../../constants";
import { TranslationService } from "../translation";
import { Observable, of } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class ProductAppResolverService {
  readonly #translationService = inject(TranslationService);
  /**
   * Returns the name of product if the product is recognized in param path or null if not.
   * @param path @{@link string}
   * @returns {@link PathProductName} or null
   */
  getProductFromPath(path: string): PathProductName | null {
    if (path.search("testdaf") !== -1) {
      return "testdaf";
    } else if (path.search("onset") !== -1) {
      return "onset";
    } else if (path.search("duo") !== -1) {
      return "duo";
    } else if (path.search("general") !== -1) {
      return "general";
    } else if (path.search("digitaler-testas") !== -1) {
      return "digitaler-testas";
    } else if (path.search("testas") !== -1) {
      return "testas";
    } else if (path.search("dtz") !== -1) {
      return "dtz";
    } else if (path.search("inl") !== -1) {
      return "inl";
    } else if (path.search("dmat") !== -1) {
      return "dmat";
    } else if (path.search("gjudaf") !== -1) {
      return "gjudaf";
    } else {
      return null;
    }
  }
  /**
   * Returns the name of module if the module is recognized in param path or null if not.
   * @param path @{@link string}
   * @returns {@link PathModuleName} or null
   */
  getModuleFromPath(path: string): PathModuleName | null {
    if (path.search("iam") !== -1) {
      return "iam";
    } else if (path.search("honorarkraft") !== -1) {
      return "hkv";
    } else if (path.search("media") !== -1) {
      return "media";
    } else if (path.search("itembank") !== -1) {
      return "itembank";
    } else if (path.search("course") !== -1) {
      return "course";
    } else if (path.search("licence") !== -1) {
      return "licence";
    } else if (path.search("grading") !== -1) {
      return "onscreen-grading";
    } else if (path.search("participant") !== -1) {
      return "participant";
    } else if (path.search("event") !== -1) {
      return "event";
    } else if (path.search("author") !== -1) {
      return "author";
    } else if (path.search("esa") !== -1) {
      return "esa";
    } else if (path.search("dmat") !== -1) {
      return "dmat";
    } else {
      return null;
    }
  }

  /**
   * Returns the logo cased version of the product based on the url. If not resolved empty string will be returned.
   *
   * @param path {@link string} current browser url
   * @returns {@link string} logo product string (TestAs, TestDaf, DUO) or empty string if not resolved
   */
  getLogoProductName(path: string): Observable<string> {
    const product = this.getProductFromPath(path);
    switch (product) {
      case "testdaf": {
        return this.#translationService.translateKeyDeferred("GAST-COMMON-NG.PRODUCT.TESTDAF", product);
      }
      case "onset": {
        return this.#translationService.translateKeyDeferred("GAST-COMMON-NG.PRODUCT.ONSET") || product;
      }
      case "testas": {
        return this.#translationService.translateKeyDeferred("GAST-COMMON-NG.PRODUCT.TESTAS") || product;
      }
      case "duo": {
        return this.#translationService.translateKeyDeferred("GAST-COMMON-NG.PRODUCT.DUO") || product;
      }
      case "general": {
        return this.#translationService.translateKeyDeferred("GAST-COMMON-NG.PRODUCT.GENERAL") || product;
      }
      case "digitaler-testas": {
        return this.#translationService.translateKeyDeferred("GAST-COMMON-NG.PRODUCT.DIGITAL_TESTAS") || product;
      }
      case "dtz": {
        return this.#translationService.translateKeyDeferred("GAST-COMMON-NG.PRODUCT.DTZ") || product;
      }
      case "inl": {
        return this.#translationService.translateKeyDeferred("GAST-COMMON-NG.PRODUCT.INL") || product;
      }
      case "gjudaf": {
        return this.#translationService.translateKeyDeferred("GAST-COMMON-NG.PRODUCT.INL") || product;
      }
      default:
        return of("");
    }
  }
}
